<script setup>
import { computed, onMounted, watch } from 'vue';
import { useSharedOffcanvas } from '@vuejs/composables/useSharedOffcanvas';
import Loader from '@vuejs/components/Loader.vue';

const sharedOffcanvas = useSharedOffcanvas();

onMounted(() => {
    window.addEventListener('DOMContentLoaded', () => {
        let eventAttached = false;

        const offcanvasElement = document.querySelector('#shared-offcanvas-app');

        if (window.IS_MOBILE) {
            offcanvasElement.classList.add('offcanvas-bottom');
        } else {
            offcanvasElement.classList.add('offcanvas-end');
        }

        const offcanvasInstance = new window.bootstrap.Offcanvas(offcanvasElement, {
            backdrop: 'static',
            keyboard: false,
        });

        window.bootstrap.offcanvas = offcanvasInstance;

        window.bootstrap.offcanvas._element.addEventListener('shown.bs.offcanvas', () => {
            if (!eventAttached) {
                window.bootstrap.offcanvas._backdrop._element.addEventListener('click', () => {
                    sharedOffcanvas.hide();
                });
            }

            eventAttached = true;
        });

        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && sharedOffcanvas.getCurrent) {
                sharedOffcanvas.hide();
            }
        });
    });

    window.addEventListener('vue.offcanvas.show', ({ detail: { componentName, payload } }) => {
        sharedOffcanvas.show(componentName, payload);
    });

    window.addEventListener('vue.offcanvas.replace', ({ detail: { componentName, payload } }) => {
        sharedOffcanvas.replace(componentName, payload);
    });

    window.addEventListener('vue.offcanvas.hide', (e) => {
        sharedOffcanvas.hide();
    });

    window.addEventListener('vue.offcanvas.hide-all', (e) => {
        sharedOffcanvas.hideAll();
    });
});
</script>

<template>
    <div class="offcanvas-content bg-white shadow position-relative overflow-auto h-100"
        :aria-label="sharedOffcanvas.currentOffcanvas?.title || 'Offcanvas'">
        <span class="p-4 px-lg-6 py-lg-3 position-absolute top-0 end-0 cursor-pointer z-1 x-mark">
            <!-- <template v-if="sharedOffcanvas.getAmount.value > 1">
                <span @click="sharedOffcanvas.hide" class="fs-6 text-capitalize text-custom-5">
                    <font-awesome-icon :icon="['fal', 'angle-left']" class="me-2 fs-5" />
                    {{ $t('global.go-back') }}</span>
            </template> -->
            <!-- <template> -->
            <button class="btn btn-link btn-sm d-flex align-items-center py-1 px-3 me-1 mt-n1 mt-lg-0 me-lg-0"
                :aria-label="$t('global.close')" @click="sharedOffcanvas.hideAll">
                <font-awesome-icon :icon="['fal', 'xmark']" class="fs-3" />
            </button>
            <!-- </template> -->
        </span>

        <template v-if="sharedOffcanvas.getCurrent.value">
            <KeepAlive>
                <Suspense timeout="0">
                    <component :is="sharedOffcanvas.getCurrent.value.component"
                        v-bind="sharedOffcanvas.getCurrent.value.payload">
                    </component>

                    <template #fallback>
                        <Loader />
                    </template>
                </Suspense>
            </KeepAlive>
        </template>
    </div>
</template>

<style lang="scss">
.offcanvas-content {
    z-index: 100;
}
</style>
